import { Injectable } from '@angular/core';
import { Company } from '@core/models/company.model';
import { Organization, OrganizationType } from '@core/models/organization.model';
import { QueryEntity } from '@datorama/akita';
import { of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrganizationState, OrganizationStore } from './organization.store';

@Injectable({ providedIn: 'root' })
export class OrganizationQuery extends QueryEntity<OrganizationState> {
  constructor(protected store: OrganizationStore) {
    super(store);
  }

  public selectChosenOrganization(): Observable<Organization> {
    return this.selectActive();
  }

  public selectChosenOrganizationType(): Observable<OrganizationType> {
    return this.selectChosenOrganization().pipe(map((organization) => organization?.type));
  }

  public selectChosenManagingCompany(): Observable<Company> {
    return this.selectChosenOrganization().pipe(map((organization) => organization?.companies?.[0]));
  }
}

export class OrganizationQueryTestDouble {
  public selectChosenOrganization = () => of({});
  public selectChosenOrganizationType = () => of('investor');
  public selectChosenManagingCompany = () => of({});
}
